<template>
  <div>
    <div class="container"><privacy-service></privacy-service></div>
  </div>
</template>

<script>
  import PrivacyService from '../../components/privacyService/PrivacyService.vue'

  export default {
    name: 'privacy-terms-page',
    components: {
      PrivacyService
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// PrivacyService.vue?2aa80d4e